import {
  URL_CESCO,
  URL_COMMUNICATIONS,
  URL_GENERAL_CONDITIONS,
  URL_MARKETING,
  URL_PRIVACY,
} from './constants';

export const createTransLinksComponents = (handleModal: () => void) => ({
  terms: <a href={URL_GENERAL_CONDITIONS} target="_blank" rel="noopener" />,
  communications: (
    <a href={URL_COMMUNICATIONS} target="_blank" rel="noopener" />
  ),
  marketing: <a href={URL_MARKETING} target="_blank" rel="noopener" />,
  privacy: <a href={URL_PRIVACY} target="_blank" rel="noopener" />,
  cesco: <a href={URL_CESCO} target="_blank" rel="noopener" />,
  legalterms: <a onClick={handleModal} />,

  // Bold text
  bold: <b style={{ fontWeight: 'bold' }} />,
});
